// Structured Data (JSON-LD) for SEO — keep claims honest (founded 2025, Jaipur primary).

export const getOrganizationSchema = (siteUrl) => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "CodeInventiv Solutions",
  "url": siteUrl,
  "logo": `${siteUrl}/assets/logo-light.png`,
  "description": "CodeInventiv Solutions builds custom software, web applications, and mobile apps for businesses. Founded in 2025. Based in Jaipur, India.",
  "foundingDate": "2025",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "A-37 Balaji Vihar-62 Niwaru Road Jhotwara",
    "addressLocality": "Jaipur",
    "addressRegion": "Rajasthan",
    "postalCode": "302012",
    "addressCountry": "IN"
  },
  "contactPoint": [
    {
      "@type": "ContactPoint",
      "telephone": "+91-8769472154",
      "contactType": "customer service",
      "areaServed": "IN",
      "availableLanguage": ["English", "Hindi"]
    },
    {
      "@type": "ContactPoint",
      "telephone": "+971-545476785",
      "contactType": "customer service",
      "areaServed": "AE",
      "availableLanguage": ["English", "Arabic"]
    }
  ],
  "email": "info@codeinventivsolutions.com",
  "sameAs": [
    "https://facebook.com/profile.php?id=61583407715494",
    "https://linkedin.com/company/codeinventiv-solutions",
    "https://instagram.com/codeinventivsolutions"
  ]
});

export const getServiceSchema = (siteUrl, serviceName, description) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  "serviceType": serviceName,
  "provider": {
    "@type": "Organization",
    "name": "CodeInventiv Solutions",
    "url": siteUrl
  },
  "areaServed": {
    "@type": "Country",
    "name": "India"
  },
  "description": description,
  "url": siteUrl
});

export const getBreadcrumbSchema = (siteUrl, items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": items.map((item, index) => ({
    "@type": "ListItem",
    "position": index + 1,
    "name": item.name,
    "item": `${siteUrl}${item.url}`
  }))
});

export const getLocalBusinessSchema = (siteUrl, location = "india") => {
  const locations = {
    india: {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "CodeInventiv Solutions",
      "image": `${siteUrl}/assets/logo-light.png`,
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "A-37 Balaji Vihar-62 Niwaru Road Jhotwara",
        "addressLocality": "Jaipur",
        "addressRegion": "Rajasthan",
        "postalCode": "302012",
        "addressCountry": "IN"
      },
      "url": siteUrl,
      "telephone": "+91-8769472154",
      "priceRange": "$$",
      "openingHoursSpecification": {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "10:00",
        "closes": "18:00"
      }
    },
    dubai: {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "CodeInventiv Solutions — UAE Contact",
      "image": `${siteUrl}/assets/logo-light.png`,
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "1402, Home to Home, Tecom, Al Barsha",
        "addressLocality": "Dubai",
        "addressRegion": "Dubai",
        "addressCountry": "AE"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "25.1007",
        "longitude": "55.1747"
      },
      "url": siteUrl,
      "telephone": "+971-545476785",
      "priceRange": "$$",
      "openingHoursSpecification": {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "10:00",
        "closes": "18:00"
      }
    }
  };
  return locations[location] || locations.india;
};

